/* @flow */

module.exports = {
  "LOCALE": {
    "ISO": {
      "639-1": "da",
      "3166-1": "DK",
      "IETF": "da-DK",
    },
    "CURRENCY": "DKK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "point",
    "BASIC_POINTS": "Niveaupoint",
    "EXTRA_POINTS": "Bonuspoint",
  },
  "COOKIE_CONSENT": {
    "ALL": "Tillad alle",
    "SELECTED": "Tillad valg",
    "NECESSARY": "Tillad nødvendigt",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "CURRENCY_SHORT": {
    "NOK": "kr",
    "DKK": "kr",
    "SEK": "kr",
    "EUR": "€",
  },
  "LANGUAGE_SWITCHER": {
    "CLOSE": "Luk sprogskifter",
  },
  "CLOSE_SYSTEM_MESSAGE": "Luk besked",
  "META": {
    "GOOGLE_SITE_OWNER": "JE5RJH9mE7LLsEhBFrF7e0T3poF_BesW7P3wibE8XwA",
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=d9bf99889b940a812162f13317162553",
  },
  "SKIP_TO_CONTENT": "Gå til indhold",
  "LOGO": {
    "ALT": "SAS",
    "TITLE": "Gå til startsiden",
  },
  "APP": {
    "COUNTRY_MODAL": "Du er logget ind med en EuroBonus-konto registreret i %country. Vil du skifte land?",
  },
  "HOMEVIEW": {
    "POPULAR_CATEGORIES": "Populære kategorier",
    "SEE_MORE_POPULAR_CATEGORIES": "Se mere kategorier",
    "POPULAR_PRODUCTS": "Populære produkter",
    "SEE_MORE_POPULAR_PRODUCTS": "Se mere populære produkter",
    "RECENTLY_VIEWED_PRODUCTS": "For nyligt viste produkter",
  },
  "ALL_PRODUCTS": {
    "TITLE": "Alle produkter",
    "TITLE_PREFIX_LOADING": "Indlæser alle",
  },
  "PRODUCTLIST_HERO": {
    "PRODUCTS_FROM": "Produkter fra",
    "TITLE_PREFIX_EMPTY": "Ingen produkter at vise",
    "TITLE_PREFIX_SINGULAR": "Viser 1 produkt i <span>%title</span>",
    "TITLE_PREFIX_PLURAL": "Viser %itemsCount produkter i <span>%title</span>",
    "IN_PRICERANGE": " i prisklassen <span>%points point</span>",
    "POINTS": "point",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikel %current af %total",
    "CONTROLS": {
      "LABEL": "Navigation for karrusel",
      "PREV_ITEM_GROUP_LABEL": "Forrige artikelgruppe",
      "NEXT_ITEM_GROUP_LABEL": "Næste artikelgruppe",
      "GO_TO_ITEM_GROUP_LABEL": "Gå til artikelgruppe %number",
      "PLAY_LABEL": "Start automatisk afspilning",
      "PAUSE_LABEL": "Sæt automatisk afspilning på pause",
    },
  },
  "ADVENT_CALENDAR": {
    "TEXT": "Julekalender",
    "LINK": "/advent-calendar",
    // "LINK": "/advent-calendar?testDate=2020-12-1&password=foo",
    "DOOR_TITLE": "Låge %day",
    "VIEW_ALL_PRODUCTS": "Vis alle produkter",
    "BACK": "Tilbage til julekalenderen",
    "SAVE_PERCENTAGE": "Spar op til  %percentage%",
    "CATEGORY_URL": "advent-calendar",
    "OPEN_DOOR": "Åbne låge",
    "OPEN_DOOR_ALT": "Åben låge",
    "CLOSED_DOOR_ALT": "Lukket låge",
    "CALENDAR_CLOSED": "Julekalenderen er lukket",
    "TOTAL_COUNT_EMPTY": "Ingen produkter at vise",
    "TOTAL_COUNT_SINGULAR": "Viser 1 produkt",
    "TOTAL_COUNT_PLURAL": "Viser %totalCount produkter",
    "LANDING": {
      "HEADING": "EUROBONUS SHOP JULEKALENDER",
      "TEXT": "Spændende tilbud hver dag indtil juleaften, med start den første december.",
    },
    "FORM": {
      "SUBSCRIBE_NOW": "Gå ikke glip af den første luge – tilmeld dig nu!",
      "EMAIL": "E-mail",
      "SUBMIT": "Bekræft tilmelding",
    },
  },
  "ACCOUNT": {
    "MY_ACCOUNT": "Min konto",
    "LOGOUT": "Log ud",
    "ACCOUNT_INFORMATION": "Kontooplysninger",
    "OWNER": "Medlem",
    "MEMBERSHIP": "Medlemskab",
    "MEMBERSHIP_LEVEL": "Medlemsniveau",
    "MEMBER_NUMBER": "EuroBonus-nummer",
    "LAST_REGISTERED_POINTS": "Sidste registrerede point",
    "POINTS_READ_MORE": "Du kan læse mere om dine point på",
    "POINTS_READ_MORE_LINK": "https://www.sas.dk/",
    "SHIPPING_ADDRESS": "Leveringsadresse",
    "ELAPSED_POINTS": "Point der snart udløber",
    "ELAPSING_POINTS_INFO": "Du har %points point, der udløber den %date (%dateRelative)",
    "EDIT_INFO_TEXT": "Du ændrer dine oplysninger på sas.dk",
    "EDIT_INFO": "Skift mine oplysninger",
    "WISHLIST": "Ønskeliste",
    "EMAIL": "E-mail",
    "BALANCE": "Saldo",
    "TOTAL_POINTS": "I alt",
    "DATE": "Dato",
    "SEE_ALL": "Se alt",
    "BUY_AND_TRANSFER_POINTS": "Køb eller giv point væk",
    "EDIT": "Ændre",
    "EDIT_ADDRESS": "Skift adresse",
    "EDIT_COUNTRY": "Skift land",
    "EDIT_URL": "https://www.sas.dk/profile/#/profile?userAction=Settings",
    "READ_MORE": "Læs mere",
    "TIER": {
      "B": "Medlem",
      "S": "Sølv",
      "G": "Guld",
      "D": "Diamant",
      "P": "Pandion",
    },
  },
  "COUNTRY": {
    "HEADING": "Velkommen!",
    "DELIVER_TO": "Leverer til",
  },
  "ORDER_HISTORY": {
    "PAGINATION": "Side %current / %total",
  },
  "PURCHASE_POINTS": {
    "CUSTOMER_NOT_ELIGABLE": "Du har ikke adgang til at købe og overføre point endnu. For at købe, overføre eller modtage Bonuspoint skal du have været medlem i mindst 1 år og have mindst en aktivitet registreret på din EuroBonus-konto. Derudover skal du have mindst 1.000 point tilgængelige på din konto. Hvis du har brug for flere point for at nå det næste medlemskabsniveau eller forblive på dit nuværende niveau, kan du købe de nødvendige Niveaupoint. Dette er især nyttigt, hvis du mangler et begrænset antal point.",
    "STEP_NAMES": {
      "find-recipient": "Find medlem",
      "point-select": "Vælg beløb",
      "payment-split": "Distribuer betaling",
      "payment": "Oversigt",
    },
    "TITLE": "Køb og overfør point",
    "DESCRIPTION": "Her kan du købe og overføre Bonuspoint eller Niveaupoint.",
    "BALANCE": "Din pointbalance er %balance",
    "BASIC_POINTS_EARNED": "Du har indtil videre optjent %earned Niveaupoint i den aktuelle kvalificeringsperiode.",
    "BUY_FOR_FRIEND": "Køb til en ven",
    "TRANSFER_TO_FRIEND": "Overføre til en ven",
    "BUY_FOR_SELF": "Køb for dig selv",
    "EDIT": "Endre",
    "SAVE_AND_PROCEED": "Gem",
    "CHOOSE": "Vælg",
    "CALCULATING": "…",
    "HOW_MANY_POINTS_PURCHASE": "Hvor mange point vil du købe?",
    "HOW_MANY_POINTS_TRANSFER": "Hvor mange Bonuspoint vil du overføre?",
    "YOU_WILL_RECEIVE": "Du køber",
    "SELECT_POINTS_TOOLTIP_TITLE": "Vælg beløb",
    "SELECT_POINTS_TOOLTIP_DESCRIPTION": "Træk slideren for at vælge, hvor mange point du vil købe eller overføre",
    "PAYMENT_TOOLTIP_TITLE": "Hvordan vil du betale transaktionsomkostningerne?",
    "PAYMENT_TOOLTIP_DESCRIPTION": "Træk slideren for at justere, hvordan du vil betale transaktionsomkostningerne. Hvis du kun vil bruge point, skal du trække skyderen helt til højre, og hvis du kun vil betale med penge i stedet, skal du trække den helt til venstre.",
    "RECIPIENT": "Modtagere",
    "WHO_IS_RECIPIENT": "Hvem er modtageren?",
    "CONFIRMATION": "Bekræftelse",
    "CONFIRMATION_SUBTITLE": "Hvordan vil du betale transaktionsomkostningerne?",
    "FAQ": {
      "TITLE": "Spørgsmål og svar",
      "1": {
        "Q": "Pointene, jeg vil overføre til en anden, er ved at udløbe. Hvor længe er de gyldige på den nye konto?",
        "A": "Når Bonuspoint overføres bliver de gyldige 5 år fra overførselsdatoen. Bemærk venligst, at hvis du fortryder købet, og bestillingen går tilbage, vil de point, der er ved at udløbe udløbe. Det betyder, at du ikke kan få point tilbage, som er forfaldet siden transaktionen.",
      },
      "2": {
        "Q": "Hvem kan købe EuroBonus Bonuspoint?",
        "A": "For at kunne købe, overføre eller modtage Bonuspoint skal du have været medlem i mindst 1 år, og der skal have været registreret mindst én aktivitet på EuroBonus-medlemskortet. Du skal derudover have mindst 1.000 point til rådighed på din konto.",
      },
      "3": {
        "Q": "Kan jeg nå et højere medlemsniveau, hvis jeg køber Bonuspoint, eller får tilført Bonuspoint til min konto?",
        "A": "Nej, Bonuspoint kvalificerer ikke til et højere medlemsniveau. For at opnå et højere medlemsniveau skal du have Niveaupoint. Det er kun muligt at optjene Niveaupoint, hvis du har optjent størstedelen af dine Niveaupoint via rejser.",
      },
      "4": {
        "Q": "Hvor mange point kan et medlem få overført fra et andet medlem pr. år?",
        "A": "Uanset om det er købte eller overførte Bonuspoint, kan modtageren få op til 100.000 EuroBonus Bonuspoint pr. år.",
      },
      "VIEW_MORE": "Se flere spørgsmål og svar",
    },
    "FIND_RECIPIENT": {
      "EB": "EuroBonus-nummer",
      "FIND_TRAVELER": "Find medlem",
      "LAST_NAME": "Etternavn",
      "SUCCESS": "Medlemmet kan modtage yderligere %points point i år.",
    },
    "PAYMENT_BOX": {
      "TITLE": "Hvordan vil du betale transaktionsomkostningerne?",
      "PAY_WITH_POINTS": "Betal med point (+%points point)",
      "PAY_WITH_CASH": "Direkte betaling (+%cash kr)",
      "SUMMARY": "Beløb",
      "GIFTED_POINTS": "Antall point",
      "TRANSACTION_FEE": "Transaktionsomkostninger",
      "TO_PAY": "At betale",
      "TRANSFER_POINTS": "Overfør point",
    },
    "SUCCESS": {
      "TITLE": "Point overført",
      "ORDER_NUMBER": "Ordernummer",
      "ORDER_OVERVIEW": "Orderoversikt",
      "CONFIRMATION": "Bekreftelse",
      "CONFIRMATION_INFO": "Du har nu gennemført en overførsel af EuroBonus-point til %member. Her er detaljer om din overførsel. En kvittering sendes til din e-mail. Hvis du har spørgsmål, bedes du kontakte vores kundeservice her.",
      "INFORMATION": "Information",
      "INFORMATION_INFO": "EuroBonus-point overføres med det samme, men det kan tage op til 24 timer, før de vises på modtagerens konto. Hvis du har spørgsmål, bedes du kontakte vores kundeservice.",
      "CONTACT_US": "Ta kontakt med kundeservice",
      "CONTACT_US_INFO": "Hvis du har spørsmål angående sortimentet eller bestillingen din, kan du kontakte oss!",
      "CUSTOMER_SERVICE": "Kundeservice",
      "TRAVELER": "Medlem",
      "EUROBONUS_NUMBER": "EuroBonus-nummer",
      "LAST_NAME": "Etternavn",
      "ORDER_CONTENTS": "Orderindhold",
      "PRODUCT": "Kjøpte poeng",
      "PAYMENT": "Betalningsfordeling",
      "CASH": "Kortbetaling",
      "POINTS": "Poeng",
    },
    "STEPS": {
      "TRAVELER": "Modtager",
      "PURCHASE_POINTS": "Antall",
      "CONFIRMATION": "Bekræftelse",
      "SUMMARY": "Opsummering",
      "PAYMENT": "Betaling",
    },
    "TIERS": {
      "EARNED_CURRENT": "Du har optjent %points i din nuværende kvalifikationsperiode.",
      "EARNED_PREVIOUS": "Du optjente i alt %points i din forrige kvalifikationsperiode.",
      "EXTEND": "Køb yderligere %points for at udvide din",
      "UPGRADE": "Køb yderligere %points for at opgradere til",
      "LEVEL": "medlemskab.",
    },
    "BASIC_POINTS": {
      "HEADER": "Køb Niveaupoint",
      "INFO": "Din konto opfylder ikke kravene for at købe Niveaupoint.",
      "LINK": "For mere information læs her.",
    },
  },
  "SORT": {
    "OFFCANVAS": {
      "TITLE": "Sortere",
      "SHOW_RESULT": "Vis resultat",
      "CLOSE_MENU": "Luk sorteringsmenuen",
    },
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alle filtre",
      "FILTER_BY_POINTS": "Filtrer efter point",
      "FILTER_BY_PRICE": "Filtrer efter pris",
      "PRICE_RANGE_MIN": "%min point",
      "PRICE_RANGE_MAX": "%max point",
      "SORT": "Sortere",
      "SORT_DEFAULT": "Valgte",
      "SORT_PRICE_DOWN": "Dyreste",
      "SORT_PRICE_UP": "Billigste",
      "SORT_NAME_DOWN": "Produktnavn Ø-A",
      "SORT_NAME_UP": "Produktnavn A-Ø",
      "SORT_POSITION_DOWN": "Mest populære",
      "SORT_POPULAR_DOWN": "Mest populære",
      "SORT_VALUE_DOWN": "Værdi: Lav",
      "SORT_VALUE_UP": "Værdi: Høj",
      "SORT_RELEASE_DATE_DOWN": "Udgivelsesdato: Seneste",
      "SORT_RELEASE_DATE_UP": "Udgivelsesdato: Ældste",
      "SORT_LATEST_DOWN": "Seneste",
      "SORT_MANUFACTURER_DOWN": "Varemærke: Ø-A",
      "SORT_MANUFACTURER_UP": "Varemærke: A-Ø",
      "SORT_CREATED_AT_DOWN": "Sidst tilføjet: Senest",
      "SORT_CREATED_AT_UP": "Sidst tilføjet: Ældste",
      "SORT_RELEVANCE_DOWN": "Mest relevant",
      "SORT_RELEVANCE_UP": "Mindst relevant",
      "RANGESLIDER": "Skydeknap",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total produkter",
      "SHOW_RESULT": "Vis resultast",
      "CLOSE_MENU": "Luk filtermenuen",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Ryd filtre",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filtre",
      "PRICE_RANGE": "Pris (%range)",
      "TOTAL_COUNT": "Viser %count produkter",
      "REMOVE": "Fjern filter",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrer efter point",
      "FILTER_BY_POINTS": "Filtrer efter pris",
      "RESET_PRICE": "Ryd filtre",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
      "BALANCE_FILTER": "Filtrer efter balance (%value point)",
      "WITHIN_BALANCE": "Produkter inden for pointbalance",
    },
  },
  "WISHLIST": {
    "TITLE": "Ønskeliste",
    "ADD_TO_WISHLIST": "Føj til ønskeliste",
    "REMOVE_FROM_WISHLIST": "Fjern fra ønskelisten",
    "EMPTY": "Du har ingen produkter på din ønskeliste.",
    "EXPLORE_ASSORTMENT": "Udforsk vores sortiment",
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Efternavn",
    "STREET_1": "Adresse 1",
    "STREET_2": "Adresse 2 (frivillig)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
    "EDIT": "Ændre",
    "NOT_YOUR_COUNTRY": "Ikke dit land?",
  },
  "OR": "eller",
  "CART": {
    "EMPTY": "Kurven er tom",
    "CANT_AFFORD_TITLE": "For lav point balance",
    "CANT_AFFORD_INFO": "Du har ikke nok point til at lave denne bestilling.",
    "OF": "af",
    "NAV_BUTTON_OPEN": "Åbn indkøbskurv - %count vare(r)",
    "NAV_BUTTON_CLOSE": "Luk indkøbskurv - %count vare(r)",
    "NAV_BUTTON_CART": "Gå til indkøbskurv - %count vare(r)",
    "CTA": "Gå til kassen",
    "ALT": "Skift i indkøbskurv",
    "EDIT": "Skift i indkøbskurv",
    "TO_PAY": "At betale",
    "INCREMENT": "Øg mængden",
    "DECREMENT": "Reducer mængden",
    "QUANTITY": "Antal",
    "CONTINUE_SHOPPING": "bliv ved med at shoppe",
    "SHIPPING": "Fragt",
    "SUBTOTAL": "Beløb",
    "GRANDTOTAL": "Total",
    "YOUR_BALANCE": "Din pointsaldo",
    "SUMMARY": "Opsummering",
    "TO_CHECKOUT": "Gå til kassen",
    "TO_CHECKOUT_CANT_AFFORD": "Du har ikke nok point til at gennemføre dette køb.",
    "REMOVE_PRODUCT": "Fjern produktet",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra indkøbskurven?",
    "YOULL_EARN": "Du optjener %points",
    "MINIMIZE_SUMMARY": "Minimer overblik",
    "VIEW_DETAILS": "Vis detaljer",
    "PAY_ONLY_WITH_PTS": "Points only",
    "ACCRUAL_TOOLTIP_TITLE": "Optjen point",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "Når du køber dette produkt, optjener du EuroBonus-point. Pointene deponeres på din konto 1 måned efter købet er gennemført.",
    "CLOSE": "Luk indkøbskurv",
    "CLOSE_SUMMARY": "Luk oversigten",
    "OPEN_SUMMARY": "Åbn oversigten",
    "SUBMIT": "Gem antal",
  },
  "DIALOGUE": {
    "CANCEL": "Ophæve",
    "CLOSE": "Luk dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Luk banner",
  },
  "CHECKOUT": {
    "NEED_HELP": "Brug for hjælp? Vi er her for dig!",
    "CONTACT_CUSTOMER_SERVICE": "Gå til kundeservice",
    "TO_PAYMENT": "Gå til betaling",
    "CHOOSE_PAYMENT_METHOD": "Til betaling",
    "POINTS_TITLE": "Betal med point",
    "POINTS_BALANCE": "Du har %points, hvor mange vil du bruge?",
    "AMOUNT_TO_PAY": "At betale",
    "TOOLTIP_TITLE": "Betal med point",
    "TOOLTIP_DESCRIPTION": "I SAS EuroBonus Shop kan du handle med point, penge eller en kombination af begge. Ved at flytte på kuglen justerer du nemt, hvor mange point du vil bruge til dit køb. Hvis du ønsker at betale hele ordren med point, skal du trække kuglen ud i højre side (bemærk at en kontantbetaling kan tilkomme hvis der ikke er point til hele købet på kontoen). Vil du i stedet betale din ordre med penge, skal kuglen trækkes til venstre.",
    "POINTS": "Point",
    "CASH": "Cash",
    "PAY_WITH_CARD": "Betal med kort",
    "CARD_PAYMENT": "Betal med kort",
    "EDIT": "Ændre",
    "PAYMENT_AND_DELIVERY": "Betaling og levering",
    "DISTRIBUTION_POINTS": "EuroBonus-point",
    "DISTRIBUTION_CASH": "Supplerende betaling med kort",
    "SENT_TO": "Sendes til",
    "CONFIRM_ORDER": "Slutför beställning",
    "CONTINUE_SHOPPING": "Bliv ved med at shoppe",
    "PAYMENT_TITLE": "Hvordan vil du betale?",
    "I_ACCEPT_THE": "Jeg accepterer",
    "TERMS": "betingelserne",
    "ACCORDION_HEADER_CART": "Indkøbskurv",

    "ADDRESS": {
      "ADDRESS": "Adresse",
      "SHIPPING": "Leveringsadresse",
      "BILLING": "Kvitteringsadresse",
      "SHIP_TO_SAME_ADDRESS": "Samme adresse på kvitteringen",
      "EMPTY_ADDRESS": "Adressen er ikke komplet. Opdater venligst",
    },
    "STEPS": {
      "CART": {
        "SHORT": "Indkøbskurv",
        "LONG": "Indkøbskurv",
      },
      "SHIPPING": {
        "SHORT": "Levering",
        "LONG": "Tjek din adresse",
      },
      "PAYMENT": {
        "SHORT": "Distribuer betaling",
        "LONG": "Distribuer din betaling",
      },
      "OVERVIEW": {
        "SHORT": "Betale",
        "LONG": "Oversigt",
      },
    },
  },
  "PAYMENT": {
    "USE_CARD": "Betal med kort",
    "USE_SAVED_CARD": "Betal med gemt kort",
  },
  "PAYMENT_METHODS": {
    "APPLE_PAY": "pay",
  },
  "CUSTOMER_SERVICE": {
    "TEXT": "Kundeservice",
    "LINK": "/customer-service",
  },
  "SUCCESS": {
    "TITLE": "Ordre registreret",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Gå tilbage til butikken",
    "VALID_UNTIL": "Gyldig indtil %date",
    "WHAT_NOW": "Hvad sker der nu?",
    "ORDER_OVERVIEW": "Ordreoversigt",
    "NOT_FOUND_TITLE": "Ingen ordrer fundet.",
    "NOT_FOUND_SUBTITLE": "Kontakt kundeservice, hvis dette er forkert.",
    "CONTACT": {
      "TITLE": "Kontakt os",
      "CREATE_TICKET": "Opret sag",
      "INFO": "Har du spørgsmål vedrørende vores sortimentet eller din bestilling, så tag endelig kontakt til os!",
      "OR": "eller",
      "REGRET_PURCHASE": "Fortryd mit køb",
      "CALL_US": "RING OS",
      "CALL_US_HOURS": "Arbeidsdager mellom: 09.00-12.0",
      "CALL_US_PHONENUMBER": "+45 78 79 40 03",
    },
    "STEPS": {
      "NORMAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse vil blive sendt til %email.",
        },
        "2": {
          "HEADING": "Bearbejder",
          "TEXT": "Din bestilling vil blive sendt når alle produkterne er tilgængelige for levering. Normalt sker dette allerede næstkommende hverdag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er klar til afsendelse får du en melding fra os via e-post. I leveringsbekræftelsen finder du et sporings link så du selv kan følge pakken. Levering sker normalt indenfor 3-7 arbejdsdage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Pakken bliver leveret til det nærmeste afhentningssted, og du vil blive underrettet via SMS til det mobilnummer, du har angivet i bestillingen. Pakken vil blive opbevaret på afhentningsstedet i 14 dage.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse og dine digitale billetter/værdikoder vil blive sendt til %email snarest. Har du ikke modtaget nogen e-mail ber vi dig kigge i spam mailen før du kontakter kundeservice.",
        },
        "2": {
          "HEADING": "Bearbejder",
          "TEXT": "Din bestilling vil blive sendt når alle produkterne er tilgængelige for levering. Normalt sker dette allerede næstkommende hverdag. Digitale produkter sendes direkte til den angivne e-mail.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er klar til afsendelse får du en melding fra os via e-post. I leveringsbekræftelsen finder du et sporings link så du selv kan følge pakken. Levering sker normalt indenfor 3-7 arbejdsdage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Pakken bliver leveret til det nærmeste afhentningssted, og du vil blive underrettet via SMS til det mobilnummer, du har angivet i bestillingen. Pakken vil blive opbevaret på afhentningsstedet i 14 dage. Din digitale bestilling bliver sendt direkte til din angivne e-mail.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse sendes til %email snarest.",
        },
        "2": {
          "HEADING": "Digital levering",
          "TEXT": "Din ordre vil blive sendt direkte til %email. Hvis du ikke har modtaget en e-mail, bedes du dobbelttjekke dit spamfilter og junkmail, før du kontakter kundeservice.",
        },
      },
    },
  },
  "SERIAL_CODE": {
    "FETCH_STATUS": {
      "LOADING": "Vent mens vi indlæser din værdikode",
      "ERROR": "En fejl opstod. Din kode sendes til din e-mail",
    },
  },
  "OLD_BROWSER": {
    "INFO": "Hej! Du bruger en forældet browser. Besøg <a href=\"http://outdatedbrowser.com\" rel=\"noopener\" target=\"blank\"> opdater din browser </a> for at bruge butikken saseurobonusshop.com",
  },
  "CATEGORY": {
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
    "SEE_ALL_IN_MAIN_CATEGORY": "Se alle i %mainCategory",
  },
  "PRODUCTLIST": {
    "EMPTY": "Der er ingen produkter, der kan vises lige nu",
  },
  "POPULAR": {
    "POPULAR_PRODUCTS": "Populære produkter",
  },
  "404": {
    "TITLE": "Beklager, siden kan ikke findes.",
    "HEADING": "— 404 —",
    "SUBHEADING": "Beklager, siden kan ikke findes.",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfejl",
    "HEADING": "Serverfejl: 500",
    "SUBHEADING": "Kom snart tilbage",
    "TEXT": "",
  },
  "SLIDER": {
    "SLIDE": "Slide %number",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søg: ",
    "PLACEHOLDER": "Søg i EuroBonus-sortimentet",
    "RESULTS": "Søgeresultater for \"%query\"",
    "TYPE": {
      "CATEGORY": "Kategori",
      "PRODUCT": "Produkt",
      "BRAND": "Varemærke",
    },
    "OPEN": "Åbn søgning",
    "CLOSE": "Luk søgemenuen",
    "SEARCH_RESULT": "Fandt 1 produkt der matchede",
    "PRODUCTS_IN_SEARCH_RESULT": "Fandt %itemsCount produkter der matchede",
    "PRODUCT_IN_SEARCH_RESULT": "Fandt ét produkt der matchede",
    "EMPTY": "Der er ingen produkter at vise lige nu",
  },
  "ICONS": {
    "CHEVRON": "Pil",
    "CROSS": "Kryds",
    "SEARCH": "Forstørrelsesglas",
    "HAMBURGER": "Tre vandrette streger (hamburgerikon)",
    "HEADPHONES": "Headset med mikrofon",
    "CART": "Indkøbskurv",
    "FILTER": "Tre linjer med hver sin cirkel",
    "SORT": "Tre vandrette streger (sorteringsikon)",
    "CHECK": "Flueben",
    "PHONE": "Telefon",
    "INFO": "Cirkel med et i indeni",
    "PLUS": "Plustegn",
    "MINUS": "Minustegn",
    "SWEDEN_FLAG": "Svensk flag",
    "NORWAY_FLAG": "Norsk flag",
    "DENMARK_FLAG": "Dansk flag",
    "OTHER_FLAG": "Jordklode",
    "HEART_EMPTY": "Tomt hjerte",
    "HEART_FILLED": "Udfyldt hjerte",
    "AMEX": "Logo for Amex",
    "MASTERCARD": "Logo for Mastercard",
    "VISA": "Logo for Visa",
    "GOOGLE_PAY": "Logo for Google Pay",
    "MS_PAY": "Logo for Microsoft Wallet",
    "APPLE_PAY": "Logo for Apple Pay",
    "LINK": "Firkant med pil indeni (linkikon)",
    "HEADSUP": "Udfyldt cirkel med udråbstegn indeni",
  },
  "HEADER": {
    "SHOPNAME": "EuroBonus Shop",
    "NAVIGATION": "Navigation",
    "MAIN_NAVIGATION": "Hovedmenu",
    "SEARCH": "Søg",
    "CATEGORIES": "Kategorier",
    "BRANDS": "Varemærker",
    "CART": "Kasse",
    "LOGOUT": "Log ud",
    "LOGIN": "Log ind",
    "DELIVER_TO": "Levering til",
    "GO_TO_SAS": "Gå til sas.dk",
    "MY_ACCOUNT": "Min konto",
    "GIFTCARDS": "Gavekort",
    "CLOSE": "Luk",
    "OPEN_MENU": "Åbn menuen",
    "CLOSE_MENU": "Luk menuen",
    "GO_BACK": "Gå tilbage",
    "CONTACT": "Kontakt os",
  },
  "DRAWER": {
    "OPEN_SUBMENU": "Åbn undermenu",
    "CLOSE_SUBMENU": "Luk undermenu",
  },
  "FOOTER": {
    "LINKS": {
      "NAVIGATION": "Sidefodsmenu",
      "TERMS": {
        "TEXT": "Vilkår",
        "LINK": "/terms",
      },
      "PRIVACY_POLICY": {
        "TEXT": "Privatlivspolitik",
        "LINK": "/privacy-policy",
      },
      "ACCESSIBILITY": {
        "TEXT": "Tilgængelighed",
        "LINK": "/accessibility",
      },
    },
    "COPYRIGHT": "© %year Scandinavian Airlines System-Denmark-Norway-Sweden, org.nr 902001-7720, 195 87 Stockholm",
    "LEGAL": "Butik SAS EuroBonus drives af Crossroads Loyalty Solutions ApS (Park Allé 295, 2., 2605 Brøndby).<br />Copyright © %year Crossroads Loyalty Solutions ApS. Alle rettigheder forbeholdes.",
    "NEED_HELP": {
      "COOKIES": "Administrer cookies",
    },
  },
  "BREADCRUMBS": {
    "HOME": "Hjem",
    "HOME_URL": "/",
    "SEARCH": "Søgeresultater for \"%query\"",
    "ADVENT_CALENDAR": "Julekalender",
  },
  "PRODUCT": {
    "ADD_TO_CART": "Tilføj til kurv",
    "OUT_OF_STOCK": "Udsolgt",
    "RELATED_PRODUCTS": "Relaterede produkter",
    "CROSS_SELL_PRODUCTS": "Andre produkter, som du måske finder interessante",
    "OPTION_DROPDOWN_PLACEHOLDER": "Vælg et alternativ",
    "LOGIN_TO_PURCHASE": "Log ind for at shoppe",
    "CHANGE_IMAGE": "Skift billede",
    "GO_TO_MANUFACTURER": "Vis alle produkter fra %brand",
    "ABOUT_BRAND": "Om %brand",
    "COLOR": "Farve",
    "CHOOSE_A_COLOR": "Vælg en farve",
    "POINTS_ONLY": "Kun point",
    "EARN": "Optjen %points",
    "EARN_UP_TO": "Optjen op til %points",
    "PAY_AT_LEAST_PTS": "Du skal bruge mindst %points point når du køber dette produkt. Det resterende beløb betales med kreditkort.",
    "PAY_ONLY_WITH_PTS": "Dette produkt kan kun betales med point.",
    "DESCRIPTION": "Produktbeskrivelse",
    "EARNINGS": "Indtjening fra dette køb",
    "SHIPPING_TERMS": "Leveringsbetingelser",
    "ACCRUAL_TOOLTIP_TITLE": "Optjen point",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "Når du køber bestemte produkter, optjener du EuroBonus-point. Pointene deponeres på din konto 1 måned efter købet er gennemført.",
    "REDEMPTION_DISABLED": "Du kan ikke købe noget fra din konto lige nu. Kontakt SAS kundeservice.",
    "EXPERIENCE_URL_BUTTON": "Til produktet",
    "EXTERNAL_EXPERIENCE": "SAS Experience",
    "EXTERNAL_EXPERIENCE_URL": "/experiences-by-eurobonus",
  },
  "MISSING_ADDRESS_TEXT": "Du skal indtaste din adresse og kontaktoplysninger på <a target='_blank' href='https://www.sas.dk/profile/settings/'>sas.dk</a>",
  "MISSING_ADDRESS_TEXT_LONG": "Du skal indtaste din adresse og kontaktoplysninger på <a target='_blank' href='https://www.sas.dk/profile/settings/'>sas.dk</a> for at kunne overføre Bonuspoint, købe Bonuspoint eller Niveaupoint.",
  "STRIPE": {
    "PROCESSING": "Indlæser…",
    "CARD_NUMBER": "Kortnummer",
    "MM/YY": "MM/ÅÅ",
    "CVC": "CVC",
  },
  "NEWSLETTER": {
    "SUCCESS_TITLE": "Bekræft din e-mailadresse",
    "SUCCESS_BODY": "For at fuldføre din registrering, skal du venligst tjekke din e-mail og bekræfte din e-mailadresse ved at følge linket i den e-mail, du har modtaget fra os.",
    "ERROR_TITLE": "Noget gik galt",
    "ERROR_BODY": "Prøv venligst at registrere dig igen.",
    "FINISHED_TITLE": "Tak for din tilmelding",
  },
  "OTP": {
    "TITLE": "Bekræft din EuroBonus-konto",
    "INFO": "En verificeringskode er blevet sendt til det telefonnummer, der er registreret på din EuroBonus-profil.",
    "FIELD_LABEL": "Kode",
    "SUBMIT": "Bekræft ejerskab",
    "REQUEST_NEW_CODE_TITLE": "Har du ikke modtaget en kode?",
    "REQUEST_NEW_CODE": "Send en ny kode",
    "CUSTOMER_SERVICE": "Kontakt kundeservice",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatorisk felt",
    "EMAIL": "Venligst indtast en korrekt e-mailadresse",
    "errorInvalidEmail": "Venligst indtast en korrekt e-mailadresse",
    "errorEmailExists": "Den angivne e-mail-adresse bruges allerede",
    "PHONE": "Venligst indtast et korrekt mobilnummer",
    "NUMERIC": "Feltet må kun indeholde tal",
    "LENGTH_LT": "Feltet indeholder for mange tegn",
    "POSTCODE": "Venligst indtast et korrekt postnummer",
    "NO_SHIPPING_GB": "Ikke tilgængelig på grund af Brexit",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "En ukendt fejl er sket. Genindlæs siden igen, og prøv igen.",
    "NETWORK_ERROR": "En ukendt fejl er sket. Genindlæs siden igen, og prøv igen.",
    "PLACE_ORDER_CATCH": "En fejl opstod. Prøv igen senere.",
    "AQUIRER_DECLINE": "Betalingen er blevet afvist. Bekræft venligst dine kort-/kontooplysninger.",

    "errorUnknownProduct": "Ukendt produkt, prøv igen.",
    "errorProductQuantityNotAvailable": "Det indtastede antal er ikke tilgængeligt lige nu.",
    "errorProductNotInStock": "Desværre er det produkt, du forsøgte at tilføje i indkøbskurven, i øjeblikket ikke på lager.",
    "errorProductMaxQuantity": "Det angivne antal er i øjeblikket ikke på lager.",
    "errorProductNotChosenVariant": "Vælg %attributeLabel for at kunne tilføje produktet til din indkøbskurv.",
    "termsNotAccepted": "Du skal godkende købsbetingelserne for at fuldføre dit køb.",

    "errorNotLoggedIn": "Du er ikke logget ind. Log ind igen.",
    "errorInvalidState": "En fejl opstod. Prøv igen.",
    "errorInvalidLogin": "Forkerte loginoplysninger",
    "errorMissingCustomer": "Den kunde, du prøver at logge på, findes ikke",
    "errorInsufficientSasPointsForPurchase": "Kontosaldoen er for lav",
    "errorBlacklistedEmail": "Den angivne e-mail-adresse bruges allerede. Indtast en anden.",
    "errorEmailExists": "Den angivne e-mail-adresse bruges allerede. Indtast en anden.",
    "errorInvalidEmailOrPassword": "Forkerte loginoplysninger",

    "errorBillingAddressValidationFailed": "Ugyldig adresse. Prøv igen",
    "errorShippingAddressValidationFailed": "Ugyldig adresse. Prøv igen",
    "errorInvalidEmailAddress": "Ugyldige kontaktoplysninger",
    "errorInvalidEmail": "Ugyldig e-mailadresse",

    "errorNoItems": "Uventet fejl, prøv igen",
    "errorNoShippingMethod": "Uventet fejl, prøv igen",
    "errorProductsNotAvailable": "Uventet fejl, prøv igen",

    "errorPaymentNotAvailable": "Betalingsfejl",
    "errorInvalidPaymentMethod": "Betalingsfejl",
    "errorNoPaymentMethod": "Betalingsfejl",

    "errorFraudOrder": "Købet er ikke tilladt. Kontakt support for mere information.",
    "errorFraudProduct": "Grænsen er nået for et eller flere produkter i indkøbskurven. Kontakt support for mere information",
    "errorFraudBlacklist": "Købet er ikke tilladt. Kontakt support for mere information",

    "Your card number is incomplete": "Indtast dine kortoplysninger.",

    "YOUR_CARD_HAS_INSUFFICIENT_FUNDS": "Du har ikke dækning på kortet.",
    "YOUR_CARDS_SECURITY_CODE_IS_INCORRECT": "CVC-koden for kortet er ikke korrekt.",
    "YOUR_CARD_WAS_DECLINED": "Kortet blev nægtet.",
    "YOUR_CARD_HAS_EXPIRED": "Kortet er udløbet.",
    "AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_CARD_TRY_AGAIN_IN_A_LITTLE_BIT": "Der opstod en fejl. Prøv igen om lidt.",
    "WE_ARE_UNABLE_TO_AUTHENTICATE_YOUR_PAYMENT_METHOD_PLEASE_CHOOSE_A_DIFFERENT_PAYMENT_METHOD_AND_TRY_AGAIN": "Vi kunne ikke godkende betalingsmetoden. Prøv igen.",
    "INTERNAL_SERVER_ERROR": "Intern serverfejl.",

    "CODE_COPIED": "Værdikoden er kopieret",
    "CODE_NOT_COPIED": "Værdikoden kunne ikke kopieres.",
    "WISHLIST_VARIANT": "Vælg først et alternativ",
    "errorPointRedemptionNotAllowed": "Køb med point er lukket på din konto lige nu.",
    "ITEM_REMOVED_FROM_CART": "%name blev fjernet fra din kurv, da den ikke længere er på lager.",
    "NO_SHIPPING_GB": "På grund af Brexit og de nye regler kan vi i øjeblikket ikke levere til Storbritannien. Vi arbejder på fuld tid med dette og håber på en løsning snart.",
    "errorGeneralError": "Vi kunne desværre ikke sende dig en bekræftelseskode - prøv venligst igen senere eller kontakt SAS kundeservice.",

    // OTP
    "invalid_sso_token_or_otp": "Din session er udløbet. Log ind igen.",
    "invalid_sso_ticket": "Din session er udløbet. Log ind igen.",
    "NEW_OTP_SMS_SENT": "Ny kode blev sendt",
    "ERROR_VALIDATION": "Validation error. Check that the data is correct and try again.",
    "ERROR_OTP_EMAIL": "Issues with the mail service. Try again later. If problem remains, contact SAS support.",
    "ERROR_OTP_SMS": "Issues with the SMS service. Try again later. If problem remains, contact SAS support.",
    "ERROR_PROFILEDATA_LOOKUP": "Could not look up profile data. Try again later.",
    "SERVICE_UNAVAILABLE": "The service is currently unavailable. Try again later.",
    "ERROR_REGION_PHONE": "Cannot reach regions phone number. Try again later.",
    "ERROR_TIMEOUT": "Timeout. Wait and try again later.",
    "ERROR_MAX_ATTEMPTS_REACHED": "For mange opkald. Vent et par minutter, og prøv igen.",

    "ADVENT_CALENDAR": {
      "notModified": "E-mail-adressen er allerede registreret",
      "invalidEmail": "Ugyldig e-mailadresse",
      "success": "Du er nu registreret",
    },

    "TRANSFER_POINTS": {
      "errorNotFound": "Vi kunne ikke finde en bruger med det EuroBonus-nummer.",
      "errorTooManySuccess": "For mange søgeforsøg. Prøv igen senere.",
      "noSuccess": "En ukendt fejl er sket. Genindlæs siden igen, og prøv igen.",
      "errorCannotTransferTo": "Det er ikke muligt at overføre point til denne modtager.",
      "errorPointRedemptionNotAllowed": "Du er ikke i øjeblikket i en kvalifikations- eller henstandsperiode, hvor pointene tæller med i dit bonusniveau.",
      "errorCannotBuyForSelf": "Din konto opfylder ikke kravene for at købe point til dig selv.",
      "errorCannotBuyForOther": "Din konto opfylder ikke kravene for at købe eller overføre point til en anden konto.",
    },
  },
};
